import { UTCDeliveryPeriod } from '@epicuro-next/ataraxia/models';

import { DeliveryPeriodType, UiState } from '../../../models';
import { updateUiDeliveryState } from '../update-ui-delivery-state';

/** store preselected Future delivery period so it could be retrieved in future */
export function preSelectFutureDeliveryPeriodUi(
  state: UiState,
  { from }: UTCDeliveryPeriod | { from: null },
): UiState {
  return {
    ...updateUiDeliveryState(state, DeliveryPeriodType.Future, from),
  };
}
